import {
  GET_SETTINGS,
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_ERROR,
} from '../actions';

export const getsettingsList = () => ({
  type: GET_SETTINGS,
  payload: { }
});

export const getsettingsListSuccess = (list) => ({
  type: GET_SETTINGS_SUCCESS,
  payload: {list}
});

export const getsettingsListError = (message) => ({
  type: GET_SETTINGS_ERROR,
  payload: { message }
});
